var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGreaterThan = function SvgGreaterThan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.437.244 6.83 5.593a.572.572 0 0 1 0 .814l-5.393 5.349a.848.848 0 0 1-1.19 0 .829.829 0 0 1 0-1.18L4.86 6 .246 1.425a.83.83 0 0 1 0-1.18.846.846 0 0 1 1.19 0",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};

export default SvgGreaterThan;